export class PagesFilterModel {
   /**
   * Exibe na interface o campo 'Tipo de Data'.
   * Valor padrão: FALSE
   */
   showTipoData = false;
   /**
   * Exibe na interface o campo 'Data Inicio'.
   * Valor padrão: TRUE
   */
   showDtInicio = true;

   /**
   * Exibe na interface o label do campo 'Data Inicio'.
   * Valor padrão: Data Início
   */
   nameLabelDtInicio = 'Data Início';
   /**
   * Exibe na interface o campo 'Código do catálogo'.
   * Valor padrão: FALSE
   */
   showCodigoCatalogo = false
   /**
   * Exibe na interface o campo 'Data Fim'.
   * Valor padrão: TRUE
   */
   showDtFim = true;

   /**
   * Exibe na interface o campo 'Autoridades Certificadora'.
   * Valor padrão: TRUE
   */
   showAutoridadeCertificadora = true;

   /**
   * Exibe na interface o campo 'Autoridades de Registro'.
   * Valor padrão: TRUE
   */
   showAutoridadeRegistro = true;

   /**
   * Exibe na interface o campo 'Autoridades de Registro Emissão'.
   * Valor padrão: FALSE
   */
   showAutoridadeRegistroEmissao = false;

   /**
   * Exibe na interface o label do campo 'Data Inicio'.
   * Valor padrão: Data Início
   */
   nameAutoridadeRegistro = 'Autoridade Registro';


   /**
   * Exibe na interface o label do campo 'Data Inicio'.
   * Valor padrão: Data Início
   */
   nameAutoridadesRegistro = 'Autoridades de Registro';

   /**
   * Exibe na interface o campo 'Locais de Atendimento'.
   * Valor padrão: FALSE
   */
   showLocalAtendimento = false;

   /**
   * Exibe na interface o campo 'Parceiro'.
   * Valor padrão: FALSE
   */
   showParceiro = false;

   /**
   * Exibe na interface o campo 'Protocolo'.
   * Valor padrão: FALSE
   */
   showProtocolo = false;

   /**
   * Exibe na interface da pagina SAFEID os campos 'CPF do Titular' & 'CNPJ'.
   * Valor padrão: FALSE
   */
   showDocumentoSafeid = false;

   /**
   * Exibe na interface da pagina SAFEID os campos 'Pagamento Confirmado'.
   * Valor padrão: FALSE
   */
   showPagamentoConfirmadoSafeID = false;

   /**
   * Exibe na interface o campo 'Produtos'.
   * Valor padrão: FALSE
   */
   showProduto = false;

   /**
   * Exibe na interface o campo 'Produtos'.
   * Valor padrão: FALSE
   */
   showRenovacao = false;

   /**
   * Exibe na interface o campo 'Produto Tipo'.
   * Valor padrão: FALSE
   */
   showProdutoTipo = false;

   /**
   * Exibe na interface o campo 'Produto Modelo'.
   * Valor padrão: FALSE
   */
   showProdutoModelo = false;

   /**
   * Exibe na interface o campo 'Produto Validade'.
   * Valor padrão: FALSE
   */
   showProdutoValidade = false;

   /**
   * Exibe na interface o campo 'Número de Série do Certificado'.
   * Valor padrão: FALSE
   */
   showNumeroSerie = false;

   /**
   * Exibe na interface o campo 'Status do Protocolo'.
   * Valor padrão: FALSE
   */
   showStatusProtocolo = false;

   /**
   * Exibe na interface o campo 'Status do Hope'.
   * Valor padrão: FALSE
   */
   showStatusHope = false;

   /**
   * Exibe na interface o campo 'Status do ACI'.
   * Valor padrão: FALSE
   */
   showStatusACI = false;

   /**
   * Exibe na interface o campo 'Status do Certificado'.
   * Valor padrão: FALSE
   */
   showStatusCertificado = false;

   /**
   * Exibe na interface o campo 'Tipo de Emissão'.
   * Valor padrão: FALSE
   */
   showTipoEmissao = false;

   /**
   * Exibe na interface o campo 'Tipo de Identificação'.
   * Valor padrão: FALSE
   */
   showTipoIdentificacao = false;

   /**
   * Exibe na interface o campo 'Nome Titular'.
   * Valor padrão: FALSE
   */
   showNomeTitular = false;

   /**
   * Exibe na interface o campo 'Tipo de Data'.
   * Valor padrão: FALSE
   */
   showStatusSolicitacao = false;

   /**
   * Exibe na interface o campo 'CPF Titular'.
   * Valor padrão: FALSE
   */
   showCPFTitular = false;

   /**
   * Exibe na interface o campo 'E-mail Titular'.
   * Valor padrão: FALSE
   */
   showEmailTitular = false;

   /**
   * Exibe na interface o campo 'Razão Social'.
   * Valor padrão: FALSE
   */
   showRazaoSocial = false;

   /**
   * Exibe na interface o campo 'Documento'.
   * Valor padrão: FALSE
   */
   showDocumento = false;

   /**
   * Exibe na interface o campo 'Nome do AVP'.
   * Valor padrão: FALSE
   */
   showNomeAVP = false;

   /**
   * Exibe na interface o campo 'CPF do AVP'.
   * Valor padrão: FALSE
   */
   showCPFAVP = false;

   /**
   * Exibe na interface o campo 'Agentes de Registro'.
   * Valor padrão: FALSE
   */
   showAgenteRegistro = false;

   /**
   * Exibe na interface o campo 'Nome do ACI'.
   * Valor padrão: FALSE
   */
   showNomeACI = false;

   /**
   * Exibe na interface o campo 'CPF do ACI'.
   * Valor padrão: FALSE
   */
   showCPFACI = false;

   /**
   * Exibe na interface o campo 'Transmitido'.
   * Valor padrão: FALSE
   */
   showTransmitido = false;

   /**
   * Exibe na interface o checkbox 'Mostrar A1 não instalado'.
   * Valor padrão: FALSE
   */
   showA1NaoInstalado = false;

   /**
   * Exibe na interface o campo 'Validações Externas'.
   * Valor padrão: FALSE
   */
   showValidacaoExterna = false;

   /**
   * Exibe na interface o campo 'Validações Externas'.
   * Valor padrão: FALSE
   */
   showPrimeiraAcao = false;

   /**
   * Exibe na interface o chackbox 'SafeID'.
   * Valor padrão: FALSE
   */
   showSafeID = false;

   /**
   * Mostra os dropdowns com a opção de selecionar mais de uma opção.
   * Valor padrão: FALSE
   */
   isMultiSelect = false;
}
